import { MODIFIER_KEY } from 'lib/modifierKey'

/** Hint shown in the sidebar trigger. */
export const SHORTCUT_LABEL = `${MODIFIER_KEY} K`

export function isGlobalSearchShortcut(event: KeyboardEvent): boolean {
  if (event.key.toLowerCase() !== `k`) return false
  if (event.altKey || event.shiftKey) return false
  return event.ctrlKey || event.metaKey
}

/**
 * The Lexical rich-text editor binds Ctrl+K to link insertion, and its root is a
 * content-editable element. jsdom never sets `isContentEditable`, so also walk up for
 * the attribute. Plain inputs and textareas do not yield: Ctrl+K from a text field
 * opens the palette.
 */
export function isEditableTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false
  if (target.isContentEditable === true) return true
  const root = target.closest(`[contenteditable]`)
  return root != null && root.getAttribute(`contenteditable`) !== `false`
}
